// extracted by mini-css-extract-plugin
export var accordion = "_bm-0";
export var chevron = "_bm-3";
export var closed = "_bm-2";
export var content = "_bm-4";
export var open = "_bm-1";
export var rotate = "_bm-5";